<template>
  <div class="mt-6 text-right">
    <h2 class="text-lg font-semibold mb-2 justify-end">
      {{ $t("languages") }}
    </h2>
    <p v-html="$t('languagesContent')"></p>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class Languages extends Vue {}
</script>
